import {
    GA_Push
} from "./GoogleAnalytics";
import {
    mobile
} from "./Agent";

var metaTags = Array.from(window.document.getElementsByTagName("meta"));
var urlToShare = "https://z.ynet.co.il/mShort/content/ElectionMobilePage/?utm_source=" + (mobile() ? "m.ynet.co.il" : "ynet.co.il") + "&utm_medium=social&utm_campaign=";
var textToShare = `${metaTags.filter(x => x.attributes[0].value.includes("og:description"))[0].content} >> ${urlToShare}`;
var textShare = "בחירות 2020 לכנסת העשרים ושתיים אצלנו ב-ynet. חדשות, סקרים ודיווחים שוטפים. מגוון רחב של כתבות, סקר בחירות 2020 ודיווחים מהשטח. היכנסו ותתעדכנו.";

const shareFacebook = () => {
    GA_Push("Share to Facebook", "", "Social", "Share_Events");
    window.open("http://www.facebook.com/share.php?u=" + encodeURIComponent("https://z.ynet.co.il/mShort/content/ElectionMobilePage/?utm_source=" + (mobile() ? "m.ynet.co.il" : "ynet.co.il") + "&utm_medium=social&utm_campaign=facebook"), "_blank");
}

const shareTwitter = () => {
    GA_Push("Share to Twitter", "", "Social", "Share_Events");
    window.open("https://twitter.com/intent/tweet?text=" + encodeURIComponent(textShare + " >> " + urlToShare + "twitter"), "_blank");
}

const shareWhatsapp = () => {
    GA_Push("Share to Whatsapp", "", "Social", "Share_Events");
    if (mobile()) {
        window.open("whatsapp://send?text=" + encodeURIComponent(textShare + " >> " + urlToShare + "whatsapp"), "_parent");
    } else {
        window.open("https://web.whatsapp.com/send?phone=&text=" + encodeURIComponent(textShare + " >> " + urlToShare + "whatsapp"), "_blank");
    }
}

const openNegishut = () => {
    // GA_Push("Open", "", "Social", "Share_Events");
    // GA_Push("Accessibility", "Open Accessibility Clicked");
    window.document.getElementById('INDmenu-btn').click();
}

export {
    shareFacebook,
    shareTwitter,
    shareWhatsapp,
    openNegishut
}


// WEBPACK FOOTER //
// ./src/Components/Services/Sharing.js